import { getRequest, handleSagaError } from '../../../../utilities/requests';
import moment from 'moment';
import { saveAs } from 'file-saver';

import { takeLatest, select, put } from 'redux-saga/effects';
import {
  LOAD_DIRECT_MERCHANTS,
  setDirectMerchants,
  failedLoad
} from './reducer/directMerchants';
import {
  CHANGE_PAGE,
  SET_SEARCH_FILTER,
  SET_STATUS_FILTER,
  SET_CALENDAR_SAGA,
  CLEAR_CALENDAR_FILTER,
  DOWNLOAD_CSV,
  SET_PER_PAGE
} from './reducer/filters';
import {
  CHANGE_SORT_ORDER,
  setShowSummaryToggled,
  setShowDetailedSummaryToggled
} from './reducer/views';

function* directMerchantsFilters() {
  const search = yield select(
    state => state.merchants.directMerchants.index.filters.search
  );
  const status = yield select(
    state => state.merchants.directMerchants.index.filters.status
  );
  const per_page = yield select(
    state => state.merchants.directMerchants.index.filters.perPage
  );
  const page = yield select(
    state => state.merchants.directMerchants.index.filters.currentPage
  );
  const startDate = yield select(
    state => state.merchants.directMerchants.index.filters.startDate
  );
  const endDate = yield select(
    state => state.merchants.directMerchants.index.filters.endDate
  );
  const orderBy = yield select(
    state => state.merchants.directMerchants.index.views.orderBy
  );
  const orderDirection = yield select(
    state => state.merchants.directMerchants.index.views.orderDirection
  );
  const config = {
    per_page,
    page,
    include_stats: true
  };
  if (startDate && endDate) {
    config.start_date = startDate;
    config.end_date = endDate;
  }
  if (orderBy && orderDirection) {
    config.order_by = orderBy;
    config.order_direction = orderDirection;
  }
  Object.assign(config, {
    search,
    status
  });
  return config;
}

function* handleLoadDirectMerchants() {
  const params = yield directMerchantsFilters();
  try {
    const url = '/users';
    const response = yield getRequest(url, params);
    yield put(setDirectMerchants(response.data));
    yield handleLoadStatisticsSummary();
  } catch (error) {
    yield put(failedLoad());
  }
}

// TODO: handle local storage for merchant summary table
function* handleLoadStatisticsSummary() {
  const statisticsTotalToggled = localStorage.getItem(
    'merchants/statisticsTotalToggled'
  );
  const statisticsDetailToggled = localStorage.getItem(
    'merchants/statisticsDetailToggled'
  );
  if (statisticsTotalToggled === null || statisticsTotalToggled === 'true') {
    yield put(setShowSummaryToggled());
  }
  if (statisticsDetailToggled === null || statisticsDetailToggled === 'true')
    yield put(setShowDetailedSummaryToggled());
}

export function* loadDirectMerchantsSaga() {
  yield takeLatest(
    [
      LOAD_DIRECT_MERCHANTS,
      CHANGE_PAGE,
      SET_PER_PAGE,
      SET_SEARCH_FILTER,
      SET_STATUS_FILTER,
      SET_CALENDAR_SAGA,
      CLEAR_CALENDAR_FILTER,
      CHANGE_SORT_ORDER
    ],
    handleLoadDirectMerchants
  );
}

function* handleDownloadDirectMerchantsCsv() {
  const config = yield directMerchantsFilters();
  try {
    const url = '/users.csv';
    const response = yield getRequest(url, config, { responseType: 'blob' });
    const time = moment().format('Y-MM-D');
    saveAs(response.data, `direct-merchants-${time}.csv`);
  } catch (error) {
    yield handleSagaError(
      error,
      'Unable to download direct merchant referrals at this time. Please try again later.'
    );
  }
}

export function* downloadDirectMerchantsCsvSaga() {
  yield takeLatest(DOWNLOAD_CSV, handleDownloadDirectMerchantsCsv);
}
